import React from 'react';
import cn from 'classnames';
import { findByType } from '../utils';
import { Link } from '../components/Link';
import './CTABlock.scss';
export function CTALink({ link }) {
    var _a;
    const style = (_a = findByType(link.config, 'style')) === null || _a === void 0 ? void 0 : _a.value;
    const styleClass = style ? `style-${style}` : style;
    return React.createElement(Link, { link: link, className: cn('cta-link', styleClass, styleClass ? 'styled-button' : undefined) });
}
export function CTABlock({ data }) {
    var _a;
    const analytics = (_a = findByType(data.value.config, 'analytics_label')) === null || _a === void 0 ? void 0 : _a.value;
    return React.createElement("div", { className: "content-block-cta-block", "data-analytics-nav": analytics }, data.value.actions.map((action, i) => React.createElement(CTALink, { key: i, link: action })));
}
